import React from "react";
import "./Seguridad.css";
import bioseguridad from "../../../../new_images/Landing/Icons/Icon_bioseguridad.png";
import geolocalizado from "../../../../new_images/Landing/Icons/Icon_pasajero_geolocalizado.png";
import asistente from "../../../../new_images/Landing/Icons/Icon_chat.png";

class Opiniones extends React.Component {
  render() {
    return (
      <section style={{display:"flex", flexDirection:"column"}}>
        <div className="po_container col-lg-11">
          <div className="col-lg-9 col-md-11 col-sm-11">
            <p className="po_title">Tu seguridad es lo primordial</p>

            <p className="po_subtitle">
              Cada detalle que forma parte de nuestro servicio se ha creado teniendo en cuenta tu seguridad y la de todos los miembros de la comunidad de Tovo. 
            </p>
          </div>
          <div className="row">
            <div className="col-lg-3">
            
              <div>
                <div className="po_header">
                  <img
                    className="po_round_image"
                    src={bioseguridad}
                    alt="avatar"
                    height="10px"
                  />
                  <p className="po_name">Bioseguridad</p>
                </div>
                <div className="po_body">
                  <p className="po_review">Los conductores saben que tu seguridad es lo más importante, todos los viajes deben cumplir con la hiegene.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
            <div>
                <div className="po_header">
                  <img
                    className="po_round_image"
                    src={geolocalizado}
                    alt="avatar"
                    height="10px"
                  />
                  <p className="po_name">Viajes geolocalizados</p>
                </div>
                <div className="po_body">
                  <p className="po_review">Comparte tu viaje con las personas que se preocupan por tu seguridad, permíteles conocer tu ubicación  en tiempo real. </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
            <div>
                <div className="po_header">
                  <img
                    className="po_round_image"
                    src={asistente}
                    alt="avatar"
                    height="10px"
                  />
                  <p className="po_name">Asistente Automático</p>
                </div>
                <div className="po_body">
                  <p className="po_review">Resuelve dudas con ayuda de nuestro bot y mejora tu experiencia.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Opiniones;
